import { SET_MERCHANDISE_COST, SET_REVENUE, SET_ACTIVE_TAB, SET_VARIABLE_COSTS, SET_FIXED_COSTS } from "../actions/actionTypes";

const initialState = {
  financialSetup:{merchandiseCost: 0, revenue: "0", variableCosts:{cards: "0", taxes:"0", comissions: "0"}, fixedCosts: {HR: "0", admin: "0", occupational: "0", maintenance: "0", others: "0"}},
  activeTab: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_TAB: {
      return {
        ...state, 
        activeTab: action.payload
      }
    }
    case SET_MERCHANDISE_COST: {
      return {
        ...state,
        financialSetup: {
          ...state.financialSetup,
          merchandiseCost: action.payload
        }
      };
    }
    case SET_REVENUE: {
      return {
        ...state,
        financialSetup: {
          ...state.financialSetup,
          revenue: action.payload
        }
      };
    }
    case SET_VARIABLE_COSTS: {
      return {
        ...state,
        financialSetup: {
          ...state.financialSetup,
          variableCosts: action.payload          
        }
      };
    }
    case SET_FIXED_COSTS: {
      return {
        ...state,
        financialSetup: {
          ...state.financialSetup,
          fixedCosts: action.payload          
        }
      };
    }
    default:
      return state;
  }
}
